export const TYPES_FINANCEMENT = [
  { value: 'sous_traitance', label: 'Sous-traitance (autre OF)' },
  { value: 'entreprise_directe', label: 'Entreprise (paiement direct)' },
  { value: 'opco_subrogation', label: 'OPCO (subrogation)' },
  { value: 'cpf', label: 'CPF' },
  { value: 'france_travail', label: 'France Travail' },
  { value: 'collectivite', label: 'Collectivité / État' },
  { value: 'individuel', label: 'Individuel' },
  { value: 'autre', label: 'Autre' },
  { value: 'aft', label: 'Action de certification (AFT)' },
];

export const MODALITES_FACTURATION = [
  { value: 'journee', label: 'Journée de formation' },
  { value: 'heure_formation', label: 'Heure de formation' },
  { value: 'heure_stagiaire', label: 'Heure stagiaire (présence)' },
  { value: 'forfait', label: 'Forfait' },
  { value: 'par_candidat', label: 'Par candidat' },
];

export const TYPES_STAGIAIRE = [
  { value: 'salarie_prive', label: "Salariés d'employeurs privés hors apprentis" },
  { value: 'apprenti', label: 'Apprentis' },
  { value: 'demandeur_emploi', label: "Personnes en recherche d'emploi" },
  { value: 'particulier', label: 'Particuliers à leurs propres frais' },
  { value: 'autre', label: 'Autres stagiaires' },
];

export const TYPES_ENTREPRISE = [
  { value: 'ett', label: 'Entreprise de travail temporaire (ETT)' },
  { value: 'entreprise', label: 'Entreprise' },
  { value: 'autre', label: 'Autre' },
];

export const STATUTS_WORKFLOW = [
  { value: 'brouillon', label: 'Brouillon', color: 'bg-slate-100 text-slate-700' },
  { value: 'devis_envoye', label: 'Devis envoyé', color: 'bg-blue-100 text-blue-700' },
  { value: 'accord_client', label: 'Accord client', color: 'bg-cyan-100 text-cyan-700' },
  { value: 'accord_financeur', label: 'Accord financeur', color: 'bg-purple-100 text-purple-700' },
  { value: 'convention_signee', label: 'Convention signée', color: 'bg-indigo-100 text-indigo-700' },
  { value: 'entree_formation', label: 'Entrée en formation', color: 'bg-teal-100 text-teal-700' },
  { value: 'en_cours', label: 'En cours', color: 'bg-emerald-100 text-emerald-700' },
  { value: 'realisee_partiellement', label: 'Réalisée partiellement', color: 'bg-amber-100 text-amber-700' },
  { value: 'realisee_totalement', label: 'Réalisée totalement', color: 'bg-green-100 text-green-700' },
  { value: 'service_fait_valide', label: 'Service fait validé', color: 'bg-emerald-200 text-emerald-800' },
  { value: 'facture_emise', label: 'Facture émise', color: 'bg-blue-200 text-blue-800' },
  { value: 'facture_reglee', label: 'Facture réglée', color: 'bg-green-200 text-green-800' },
  { value: 'annulee', label: 'Annulée', color: 'bg-red-100 text-red-700' },
  { value: 'reportee', label: 'Reportée', color: 'bg-orange-100 text-orange-700' },
  { value: 'rejet_prise_en_charge', label: 'Rejet prise en charge', color: 'bg-red-200 text-red-800' },
];

export const PIECES_TYPES = [
  { value: 'devis_signe', label: 'Devis signé' },
  { value: 'convention_signee', label: 'Convention signée' },
  { value: 'bon_commande', label: 'Bon de commande' },
  { value: 'accord_prise_en_charge', label: 'Accord de prise en charge' },
  { value: 'emargement', label: "Feuille d'émargement" },
  { value: 'attestation_assiduite', label: "Attestation d'assiduité" },
  { value: 'certificat_realisation', label: 'Certificat de réalisation' },
  { value: 'facture_acquittee', label: 'Facture acquittée' },
  { value: 'rib', label: 'RIB' },
  { value: 'resultat_certification', label: 'Résultat certification' },
];
